import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import ScreenHead from '@blade-sxp/screen/components/screen-head/index.vue';
import ScreenBackhead from '@blade-sxp/screen/components/back-screen-head/index.vue';
import ScreenBackmap from '@blade-sxp/screen/components/back-map/back-render.vue';
import store from '@blade-sxp/screen/store/index';
import ScreenMap from '@blade-sxp/screen/components/map/index.vue';
import { nextTick } from 'process';
import { AccountModule } from '@blade-sxp/account/store/account';
let default_1 = class extends Vue {
    get isUe3d() {
        return AccountModule.accountInfo?.mapType === '3D_UE';
    }
    created() {
        this.init();
    }
    beforeDestroy() {
        this.closeWebSocket(); // 关闭websocket
        store.clearTimer(); // 关闭定时器
    }
    init() {
        store.fetchZoneTree();
        this.initWebSocket();
        store.initTimer();
    }
    initWebSocket() {
        store.initWebSocket();
        store.initAlarmWebSocket();
        store.initRealTimeWebSocket();
    }
    closeWebSocket() {
        store.closeAllWebSockets();
        store.closeWebSockets();
    }
    snapDateChange(time) {
        store.updateSnapTime(time);
    }
};
default_1 = __decorate([
    Component({
        name: 'Screen',
        components: { ScreenHead, ScreenMap, ScreenBackhead, ScreenBackmap },
        beforeRouteUpdate: (_to, from, next) => {
            store.updateTimeCount();
            nextTick(() => {
                store.updateIsShow(true);
            });
            next();
        },
    })
], default_1);
export default default_1;
